// Import common components
import { FlexBox, Box } from '../../common/Box'
import { Col6 } from '../../common/Grid'
import Title from '../../common/Title'
import Description from '../../common/Description'

// Import themes modules
import { px2Rem } from '../../../themes/Mixins'
import COLORS from '../../../themes/Colors'
import TYPOGRAPHY from '../../../themes/Typography'

export const Wrapper = Box.extend`
  margin: 0 ${px2Rem(2.5)};
  width: calc(50% - ${px2Rem(2.5)});
`

export const ContentWrapper = FlexBox.extend`
  margin: 0;
  flex-wrap: wrap;
  padding-top: 0;
  justify-content: space-between;

  @media(min-width: 768px) {
    flex-wrap: unset;
    padding-top: ${px2Rem(5)};
  }
`

export const TitleWrapper = FlexBox.extend`
  width: 100%;
  background-color: ${COLORS.bgTeam};
  align-items: center;
  justify-content: center;
  height: auto;
  padding: ${px2Rem(30)} ${px2Rem(25)};

  @media(min-width: 768px) {
    width: 25%;
    height: ${px2Rem(555)};
    padding: 0;
  }
`

export const MainImageWrapper = Box.extend`
  width: 100%;

  @media(min-width: 768px) {
    width: 75%;
    height: ${px2Rem(555)}
  }
`

export const DescWrapper = Box.extend`
  @media(min-width: 768px) {
    width: 50%;
  }
`

export const TeamDescription = Description.extend`
  color: ${COLORS.lighterGray};
  line-height: 1.428;
  padding: ${px2Rem(20)} ${px2Rem(25)};
  margin-bottom: 0;

  @media(min-width: 768px) {
    padding: 0 ${px2Rem(55)} 0 ${px2Rem(33)};
    line-height: ${px2Rem(25)};
  }
`

export const TeamTitle = Title.extend`
  color: ${COLORS.white};
  font-family: ${TYPOGRAPHY.TYPE.base};
  line-height: ${props => props.lineHeight || ''};
`

export const ImageWrapper = Box.extend`
  min-width: ${px2Rem(150)};
  height: ${px2Rem(150)};
  width: 25%;
`

export const ImageListWrapper = Box.extend`
  width: calc(50% - ${px2Rem(5)});
`

export const TeamImageWrapper = FlexBox.extend`
  height: ${px2Rem(220)};

  div:first-child {
    margin-left: 0;
  }

  div:last-child {
    margin-right: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/sections/team/TeamResponsive.js